/** English translations for the dashboard mapping element wizard */
import { WizardConfig } from '../translations-types';

const translations: WizardConfig = {
  whatToShow: 'What to show?',
  chooseImage: 'Choose image',
  labelSettings: 'Label settings',
  advanced: 'Configure answers',
  selectQuestionnaire: 'Select a questionnaire',
  selectQuestion: 'Select a question',
  persistentMode: 'Fixed text/image',
  persistentModeDescription: 'Always show a static text and/or image.',
  noImage: 'No image',
  refineElement: 'Would you like to refine this element?',
  addCondition: 'Show only when the answer matches a condition',
  conditionValue: 'Condition value',
  addVariant: 'Add variant',
  variant: 'Variant',
  back: 'Back',
  nextVariant: 'Next variant',
  variantExplanation: 'Create variants to show a different image or label based on the answer to the question.',
  variants: 'Variants',
  answer: 'Answer',
  addAnotherAnswer: 'Would you like to configure another answer?',
  showForEveryAnswer: 'Show image for every answer',
  showForSpecificAnswer: 'Show image for a specific answer',
  questionTypeText: 'Free text field',
  questionTypeNumber: 'Number input',
  questionTypeRating: 'Score 1-10',
  questionTypeDate: 'Date input',
  questionConfiguration: 'Question configuration',
  changeQuestionWarningTitle: 'Change question?',
  changeQuestionWarningMessage:
    'You have already configured answers for this question. Changing the questionnaire or question will remove all configured answers. Do you want to continue?',
};

export default translations;
